//libs
import React, {Component} from 'react';
import ReactTable from 'react-table';
import Select from 'react-select';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/sv';
import 'react-datepicker/dist/react-datepicker.css';
import {connect} from 'react-redux';
import Alert from 'react-s-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import qs from 'qs';
//components
import PopupVerify from './PopupVerify';
import CustomAlert from '../CustomAlert';
import printDocument from '../../printDocument';
//other
import Config from '../../config';
import {isWheelChanger, notification, isAdmin} from '../../helpers';
import {setTrue} from '../../actions/refresh';
import {wheelsShift, wheelsReverseShift, wheelsReturnWithoutShift} from '../../actions/wheels';
import PopUp from "../UI_Elements/Forms/PopUp";
import FileDownload from 'js-file-download';

moment.tz.setDefault('Europe/Stockholm');
moment.locale('sv');

class ShiftTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            selected: [],
            selectedWheels: [],
            selectedOption: null,
            wheelChangers: [],
            wheelChangerId: '',
            wheelInfo: null,
            loading: false,
            token: '',
            showPopup: false,
            showConfirmPalete: false,
            confirmPaleteAction: null,
            shippingNo: ''
        };

        this.printExcel = this.printExcel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSend = this.handleSend.bind(this);
        this.togglePopup = this.togglePopup.bind(this);
        this.prepareSend = this.prepareSend.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSelectChange = (selectedOption) => {
        this.setState({selectedOption});
    }

    togglePopup() {
        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    prepareSend(sendTO) {

        var selectedWheels = [];
        var selectedWheelIds = [];

        this.state.data.forEach((wheel, i) => {
            if (this.state.selected.includes(i)) {
                selectedWheels.push(wheel);
                selectedWheelIds.push(wheel.id);
            }
        })

        // Hämta information för att skicka till Station
        if (sendTO === 'send-to-station') {
            if (selectedWheels.length > 0 && this.state.selectedOption !== null) {
                axios.get(Config.api.getDomain() + 'wheel/sendWheelInfo', {
                    headers: Config.api.getConfig().headers,
                    params: {
                        FromLocationId: parseInt(Config.api.getWheelChangerId(), 10),
                        ToLocationId: this.state.selectedOption.id,
                        FromLocationType: 'Station',
                        ToLocationType: 'Station',
                        WheelIds: selectedWheelIds
                    },
                    paramsSerializer: qs.stringify
                })
                    .then(response => {

                        this.setState({
                            wheelInfo: response.data,
                            selectedWheels
                        });
                        this.togglePopup();
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        }

        // Hämta information för att skicka till Centrallager
        if (sendTO === 'send-to-central') {

            if (selectedWheels.length > 0) {
                axios.get(Config.api.getDomain() + 'wheel/sendWheelInfo', {
                    headers: {
                        'Authorization': "Bearer " + this.state.token,
                        pragma: 'no-cache'
                    },
                    params: {
                        FromLocationId: parseInt(Config.api.getWheelChangerId(), 10),
                        ToLocationId: 0,
                        FromLocationType: 'Station',
                        ToLocationType: 'Warehouse',
                        WheelIds: selectedWheelIds
                    },
                    paramsSerializer: qs.stringify
                })
                    .then(response => {
                        this.setState({
                            wheelInfo: response.data,
                            selectedWheels
                        })
                        this.togglePopup()
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        }
    }

    componentWillReceiveProps(props) {
        if (props.refresh.fetch['ShiftTable'] && props.refresh.fetch['ShiftTable'] === true) {
            const status = this.props.type === 'toShift' ? 'OnStation' : 'ShiftedWheel'

            const parameters = {
                status: status,
                wheelChangerId: Config.api.getWheelChangerId()
            };

            axios.get(Config.api.getDomain() + 'wheel/statusAndId', Config.api.getConfig(parameters))
                .then(res => {
                    var wheels = res.data.map(wheel => {
                        const newWheel = {
                            regNo: wheel.regNo,
                            carModel: wheel.carModel,
                            wheeltype: wheel.wheeltype.name,
                            offRentDate: wheel.offRentDateTime === null ? '' : moment(wheel.offRentDateTime).format('YYYY-MM-DD'),
                            lastOnRentDate: wheel.offRentDateTime === null ? '' : moment(wheel.lastOnRentDate).format('YYYY-MM-DD'),
                            id: wheel.id,
                            lastOrderId: wheel.lastOrderId
                        }

                        return newWheel
                    })

                    this.setState({data: wheels})
                    // this.props.setFalse('ShiftTable')
                })
                .catch(error => {
                    console.log(error);
                })
        }
    }

    componentDidMount() {
        if (localStorage.getItem('apitoken')) {
            var token = localStorage.getItem('apitoken');

            this.setState({
                wheelChangerId: Config.api.getWheelChangerId(),
                token: token
            })

            const status = this.props.type === 'toShift' ? 'OnStation' : 'ShiftedWheel'

            const parameters = {
                status: status,
                wheelChangerId: Config.api.getWheelChangerId()
            };

            this.setState({loading: true}, () => {
                axios.get(Config.api.getDomain() + 'wheel/statusAndId', Config.api.getConfig(parameters))
                    .then(res => {
                        this.setState({loading: false})
                        var wheels = res.data.map(wheel => {
                            const newWheel = {
                                regNo: wheel.regNo,
                                carModel: wheel.carModel,
                                wheeltype: wheel.wheeltype.name,
                                offRentDate: wheel.offRentDateTime === null ? '' : moment(wheel.offRentDateTime).format('YYYY-MM-DD'),
                                lastOnRentDate: wheel.lastOnRentDate === null ? '' : moment(wheel.lastOnRentDate).format('YYYY-MM-DD'),
                                id: wheel.id,
                                lastOrderId: wheel.lastOrderId
                            }

                            return newWheel
                        })

                        this.setState({data: wheels})
                    })
                    .catch(error => {
                        console.log(error);
                    })
            });

            axios.get(Config.api.getDomain() + 'crud/wheelchanger', Config.api.getConfig())
                .then(res => {
                    const wheelChangers = []

                    res.data.forEach(wheelchanger => {
                        const newWheelchanger = {
                            id: wheelchanger.id,
                            name: wheelchanger.name,
                            value: wheelchanger.name,
                            label: wheelchanger.name,
                            retailerId: wheelchanger.retailerId
                        }

                        wheelChangers.push(newWheelchanger)
                    })

                    this.setState({wheelChangers})
                })
                .catch(error => {
                    console.log(error);
                })
        }
    }

    // Skicka hjul
    handleSend(e) {
        e.preventDefault()

        var selectedWheelIds = []

        if (this.props.name === 'sendToStation') {
            selectedWheelIds = []

            this.state.data.forEach((wheel, i) => {
                if (this.state.selected.includes(i)) {
                    selectedWheelIds.push(wheel.id)
                }
            })

            let params = {
                fromLocationId: parseInt(Config.api.getWheelChangerId(), 10),
                toLocationId: this.state.selectedOption.id,
                wheelIds: selectedWheelIds,
                shippingNo: this.state.shippingNo,
                toLocationType: 1,
                fromLocationType: 1,
                orderComment: this.state.comment
            }

            axios.post(Config.api.getDomain() + 'wheel/send', params, Config.api.getConfig())
                .then(response => {
                    this.togglePopup()

                    this.setState({
                        wheelInfo: {
                            ...this.state.wheelInfo,
                            id: response.data.id
                        }
                    })

                    Alert.info(
                        <CustomAlert
                            info={{
                                ...this.state.wheelInfo,
                                selectedWheels: this.state.selectedWheels,
                                shippingNo: this.state.shippingNo,
                                pdfType: "wheelChanger"
                            }}
                            print={printDocument}
                        />, {
                            timeout: 'none'
                        })

                    this.setState({selected: []})
                    this.props.setTrue('ShiftTable')
                })
                .catch(error => {
                    console.log(error)
                    notification("Något gick fel, kunde inte skicka hjul, snälla försök igen senare.");
                })
        }

        if (this.props.name === 'sendToCentral') {
            selectedWheelIds = []

            this.state.data.forEach((wheel, i) => {
                if (this.state.selected.includes(i)) {
                    selectedWheelIds.push(wheel.id)
                }
            })

            let params = {
                fromLocationId: parseInt(Config.api.getWheelChangerId(), 10),
                toLocationId: 0,
                wheelIds: selectedWheelIds,
                shippingNo: this.state.shippingNo,
                toLocationType: 3,
                fromLocationType: 1,
                orderComment: this.state.comment
            }

            axios.post(Config.api.getDomain() + 'wheel/sendToWarehouse', params, Config.api.getConfig())
                .then(response => {
                    this.togglePopup()

                    this.setState({
                        wheelInfo: {
                            ...this.state.wheelInfo,
                            id: response.data.id
                        }
                    })
                    Alert.info(
                        <CustomAlert
                            info={{
                                ...this.state.wheelInfo,
                                selectedWheels: this.state.selectedWheels,
                                shippingNo: this.state.shippingNo,
                                pdfType: "wheelChanger"
                            }}
                            print={printDocument}
                        />, {
                            timeout: 'none'
                        })

                    this.setState({selected: []})
                    this.props.setTrue('ShiftTable')
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }

    // Skifta hjul
    handleSubmit(action) {

        const wheelIds = []

        this.state.data.forEach((wheel, i) => {
            if (this.state.selected.includes(i)) {
                wheelIds.push(wheel.id)
            }
        });


        switch(action){
            case "shift":
                this.props.wheelsShift(wheelIds);
                break;
            case "reverse-shift":
                this.props.wheelsReverseShift(wheelIds);
                break;
            case "return-without-shift":
                this.props.wheelsReturnWithoutShift(wheelIds);
                break;
            default:
                this.setState({selected: []})
                break;
        }

        this.setState({selected: []})
    }

    checkPalletCount(e) {

        const actionType =  e.target.getAttribute("data-accept-action");

        if ((actionType!=="return-without-shift") &&
            (actionType!=="shift") &&
            (actionType!=="reverse-shift") &&
            (this.state.selected.length % 3) !== 0) {
            this.setState({
                showConfirmPalete: true,
                confirmPaleteAction: e.target.getAttribute("data-accept-action")
            })

        } else {
            this.setState({
                showConfirmPalete: false,
                confirmPaleteAction: e.target.getAttribute("data-accept-action")
            });

            this.onPopupActionAccept(e,e.target.getAttribute("data-accept-action"))

        }
    }

    onPopupActionAccept(e, action) {

        if (typeof(action)==="undefined"){
            action = this.state.confirmPaleteAction;
        }

        this.confirmPaleteAction = null;
        if (action){
            switch(action){
                case "send-to-station":
                case "send-to-central":
                    this.prepareSend(action);
                    break;

                case "shift":
                case "reverse-shift":
                case "return-without-shift":
                    this.handleSubmit(action);
                    break;

                default:
                    console.log("action not found ",action);
                    break;
            }
        } else {
            console.log("action not passsed",action);
        }

        this.setState({
            showConfirmPalete: false,
            confirmPaleteAction:null
        });
    }

    onPopupActionCancel(e) {
        this.setState({
            showConfirmPalete: false,
            confirmPaleteAction:null
        })
    }

    printExcel(e) {
        e.preventDefault();
        let reportTypeName = this.props.wheelStatus === 2 ? "Att_skifta" : "Skiftade";
       
        const reportType = 10;
        const filename = reportTypeName + '_' + moment().format('YYYY_MM_DD') + '.xlsx'

        let data = {
            'reportType': reportType,
            'wheelChangerId': this.state.wheelChangerId,
            'wheelStatuses': [this.props.wheelStatus]
        }

        axios.post(Config.api.getDomain() + 'report/reportExcelExport', data, {
            headers: Config.api.getConfig().headers,
            responseType: 'blob',
        })
        .then(response => {
            FileDownload(response.data, filename)
        })
        .catch(error => {
            console.log(error)
        })
    }

    render() {

        const {selectedOption} = this.state;
        let noRestriction = false;
        if (typeof(this.props.noRestriction)!=="undefined"){
            noRestriction = this.props.noRestriction
        }

        const wheelchangerOptions = this.state.wheelChangers.map(wheelchanger => {
            return {
                label: wheelchanger.name,
                value: wheelchanger.retailerId,
                id: wheelchanger.id
            }
        })

        const selectBox = (
            <Select
                value={selectedOption}
                onChange={this.handleSelectChange}
                options={wheelchangerOptions.filter(wheelchanger => {
                    return wheelchanger.id !== parseInt(Config.api.getWheelChangerId(), 10)
                })}
                className='select-station'
                placeholder='SKICKA TILL...'
            />
        )

        const toShiftColumns = [
            {
                Header: "Regnr",
                accessor: "regNo",
                width: 80
            },
            {
                Header: "ID",
                accessor: "lastOrderId",
                width: 80
            },
            {
                Header: "Bilmodell",
                accessor: "carModel",
            },
            {
                Header: "Hjulmodell",
                accessor: "wheeltype",
            },
            {
                Header: "Off rent date",
                accessor: "offRentDate",
            },
            {
                Header: "Last on rent",
                accessor: "lastOnRentDate"
            },
        ]

        const toSendColumns = [
            {
                Header: "Regnr",
                accessor: "regNo",
                width: 80
            },
            {
                Header: "Bilmodell",
                accessor: "carModel",
            },
            {
                Header: "Hjulmodell",
                accessor: "wheeltype",
            },
            {
                Header: "Off rent date",
                accessor: "offRentDate",
            },
            {
                Header: "Last on rent",
                accessor: "lastOnRentDate"
            },
        ]

        let itemCount = "";
        if (this.state.selected.length > 0) {
            itemCount = " (" + this.state.selected.length + ")";
        }

        return (
            <div className="confirm-orders">
                <h2>{this.props.title}</h2>
             
                <div className="print-excel-wrapper">
                    <button
                        type="button"
                        className="btn yellow print-excel"
                        onClick={ this.printExcel }
                        disabled={ this.state.data.length > 0 ? false : true }
                    >
                        Hämta Excel-fil
                    </button>
                </div>

                <ReactTable
                    data={this.state.data}
                    loading={this.state.loading}
                    loadingText="Laddar..."
                    columns={this.props.type === 'toShift' ? toShiftColumns : toSendColumns}
                    minRows="0"
                    pageSize="200"
                    className="need-confirm-ordertable shift-table"
                    showPagination={false}
                    noDataText="Inga hjul hittades"
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            onClick: (e) => {
                                var a = this.state.selected.indexOf(rowInfo.index);

                                if (a === -1) {
                                    this.setState({
                                        selected: [...this.state.selected, rowInfo.index]
                                    });
                                }

                                var array = this.state.selected;

                                if (a !== -1) {
                                    array.splice(a, 1);
                                    this.setState({selected: array});
                                }
                            },
                            className: this.state.selected.indexOf(rowInfo.index) !== -1 ? 'selected' : null
                        }
                    }}
                />

                <div className="order-actions-container">
                    {!noRestriction &&
                    <div className="how-many-wheels-bubble">
                        <div>Nu har du</div>
                        <span className="how-many-wheels">
                            {this.state.selected.length} av max 42
                        </span> hjulset.
                    </div>
                    }


                    {
                        this.props.type === 'toSend' &&
                        <button
                            //onClick={this.prepareSend}
                            onClick={(e) => this.checkPalletCount(e)}
                            data-accept-action={"send-to-central"}
                            className='btn yellow send-orders'

                            name='send-to-central'
                        >
                            Skicka {itemCount}
                        </button>
                    }

                    <button
                        //onClick={this.handleSubmit}
                        onClick={(e) => this.checkPalletCount(e)}
                        data-accept-action={this.props.type === 'toShift' ? 'shift' : 'reverse-shift'}
                        className={this.props.type === 'toSend' ? 'btn white' : 'btn yellow'}
                        name={this.props.type === 'toShift' ? 'shift' : 'reverse-shift'} >
                        {this.props.type === 'toShift' ? 'Skifta däck' : 'Ångra skifte'} {itemCount}
                    </button>

                    {(this.props.type === 'toShift') && <span className='cursive'>Eller</span>}
                    {this.props.type === 'toShift' && !isWheelChanger() && selectBox}

                    {
                        this.props.type === 'toShift' && !isWheelChanger() &&
                        <input
                            type={"button"}
                            //onClick={this.prepareSend}
                            onClick={(e) => this.checkPalletCount(e)}
                            data-accept-action={"send-to-station"}
                            className="send btn white send-to-station"
                            name="send-to-station"
                            disabled={( selectedOption===null || !selectedOption || (selectedOption.length===0) || itemCount===0) ? true : false}
                            value={"Skicka "+itemCount}
                        />
                    }

                    {
                        ((this.props.type === 'toShift' && !isWheelChanger()) && isAdmin()) &&
                        <button
                            //onClick={this.handleSubmit}
                            onClick={(e) => this.checkPalletCount(e)}
                            data-accept-action={"return-without-shift"}
                            className="send btn white"
                            name="return-without-shift"
                        >
                            Returnera hjul utan att skifta på bil {itemCount}
                        </button>
                    }
                </div>

                {
                    this.state.showPopup &&
                    <PopupVerify
                        data={this.state.selectedWheels}
                        wheelInfo={this.state.wheelInfo}
                        toggleNext={this.toggleNext}
                        closePopup={this.togglePopup.bind(this)}
                        submit={this.handleSend}
                        onChange={this.handleChange}
                    />
                }


                {this.state.showConfirmPalete &&
                    <PopUp
                        onCancel={(event) => this.onPopupActionCancel(event)}
                        onAccept={(event) => this.onPopupActionAccept(event)}
                        title={"Är du säker på att du vill genomföra beställningen eller kan du lägga till " +
                        "uppsättning/uppsättningar för att optimera transportkostnaden?"}
                    >
                        <p>Beställning är inte jämt delbart med 3 vilket påverkar transportkostnaden (Det får plats 3 hjul-set per pall). Är du säker på att du vill genomföra beställningen eller kan du lägga till uppsättning/uppsättningar för att optimera transportkostnaden?</p>
                    </PopUp>
                }


            </div>
        )
    }
}

/**
 * Map state to properties
 */
const mapStateToProps = (state) => {
    return {
        refresh: state.refresh
    };
};

/**
 * Map actions to properties
 */
const mapDispatchToProps = (dispatch) => {
    return {
        setTrue: (key) => dispatch(setTrue(key)),
        wheelsShift: (wheelIds) => dispatch(wheelsShift(wheelIds)),
        wheelsReverseShift: (wheelIds) => dispatch(wheelsReverseShift(wheelIds)),
        wheelsReturnWithoutShift: (wheelIds) => dispatch(wheelsReturnWithoutShift(wheelIds))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShiftTable)


// WEBPACK FOOTER //
// ./src/components/Stock/ShiftTable.js